export default __webpack_public_path__ + "static/media/amex.ab2cb4c2.svg";